import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
});

export const STALE_TIME = {
  LIST: 5000,
  MAP: Infinity,
  COUNT: 10000,
  TYPES: 600000,
  EMBEDDED_REPORT: 300000, // 5 minutes
};

export const PAGE_SIZE = {
  FILTER_DROPDOWN: 100,
};
